import { getLanguageCode, getTwoLetterIsoName, getCapCode } from '@triumph/shared';
import { useSelector, useDispatch } from 'react-redux';
import { getLoadedConfiguration, getSelectedColour } from 'src/redux/app/selectors';
import { appendModalToDom } from 'helpers/modal';
import { setCalculations } from 'src/redux/app/actions';
import useDataLayer from './useDataLayer';
import useLabel from './useLabel';

const useOpenFinance = (bikeModel) => {
  const { price, thumbnail, colours } = bikeModel;
  const dispatch = useDispatch();
  const getLabel = useLabel();
  const pushToDataLayer = useDataLayer();
  const loadedConfiguration = useSelector(getLoadedConfiguration);
  const bikeColour = useSelector(getSelectedColour);
  const capCode = getCapCode(colours, loadedConfiguration);
  const assetId = `${bikeModel.year}${bikeModel.productCode}${bikeColour?.colourCode}`;

  const openFinanceCalculator = () => {
    if (window.financeCalculator.canOpenScfModal()) {
      window.financeCalculator.openScfModal({ noCtaEvents: true });

      setTimeout(() => {
        // Wait for calculator to mount
        appendModalToDom('purchase-intent-modal', { zIndex: 99999 });
      }, 1000);
    }

    pushToDataLayer('purchaseCal', { ctaText: getLabel('financeCalculateButtonLabel') });

    if (window.codeweavers && window.financeCalculator) {
      window.financeCalculator.openCodeweaversModal({
        noCtaEvents: true,
        financeCapCode: capCode,
        financeAmount: loadedConfiguration?.price || price,
        financeShowImage: thumbnail?.src,
        languageCode: getLanguageCode(),
        countryCode: getTwoLetterIsoName(),
        assetId: capCode || assetId,
        onCalculate: calculations => {
          dispatch(setCalculations(calculations));
        },
      });
      // Wait for Codeweavers calculation to take place and for local storage values to update
      setTimeout(() => {
        dispatch(setQuoteRef(window.localStorage.getItem('quoteRef') || ''));
      }, 3000);
    }

    if (typeof codeweavers !== 'undefined' && capCode) {
      appendModalToDom('purchase-intent-modal', { zIndex: 99999 });
    }

    if (typeof codeweavers !== 'undefined' && capCode) {
      appendModalToDom('purchase-intent-modal', { zIndex: 99999 });
    }
  };

  return openFinanceCalculator;
};

export default useOpenFinance;
